const MERCHANT_ID = '6cfe160cc150f04754367b05e711b987';
const STAFFSTARTAPI_DOMAIN = 'api.staff-start.com';

  //ページURL及びパラメータ取得


/**********************************************************************
 * 初期表示用イベントリスナー
 ***********************************************************************/
 document.addEventListener('DOMContentLoaded', () => {
  if(window.location.pathname.startsWith("/products/")){
    getProdctCoordinate();
    getProdctVoice();
  }
});
/**
 * コーディネート一覧検索
 */
 async function getProdctCoordinate(){
  var productCoordinateSearchParams = new URLSearchParams(window.location.search);
  const productCoodinateResponse = await executionCoordinateApi(productCoordinateSearchParams);

  if(productCoodinateResponse.total == 0) {
    document.querySelector('.product-staff-start__product-coordinate-pc').style.display = 'none';
    document.querySelector('.product-staff-start__product-coordinate-sp').style.display = 'none';
  } else {
    const stylingTab = document.querySelectorAll('.productDetail__info__tab__tablinks__styling')[1];
    stylingTab.style.display = 'block';
  }


  productStatusCheck(productCoodinateResponse);
  //PC,SP用の要素を取得

  const coordinatePcList = document.getElementById("product-coordinate-pc");
  const coordinateSpList = document.getElementById("product-coordinate-sp");

  let currentBrand = document.querySelector('.productDetail__info__brand__name').innerHTML.trim();

  const siteBrands = window.siteBrandData;
  const matchedBrand = siteBrands.find(brand => brand.label == currentBrand);
  currentBrand = matchedBrand.mainCode;

  var today = new Date(Date.now());
  today.setDate(today.getDate() -7);

  for (const item of productCoodinateResponse.item) {
    const fromHeight = parseInt(item.user_height) <= 149 ? '0' : parseInt(item.user_height) >= 190 ? '190' : item.user_height;
    const toHeight = parseInt(item.user_height) <= 149 ? '149' : `${(parseInt(item.user_height) + 4)}`;

    var productCoordinateString = "";
    productCoordinateString +=`<div class="coordinate-card__container">`;
    productCoordinateString +=`  <div class="coordinate-card__content">`;
    productCoordinateString +=`    <a href="/pages/coordinate-detail-${currentBrand}?cid=`;
    productCoordinateString +=item.cid;
    productCoordinateString +=`" class="coordinate-card__image__link">`;
    productCoordinateString +=`      <div class="coordinate-card__image-container">`;
    productCoordinateString +=`       <img`;
    productCoordinateString +=`        class="coordinate-card__image"`;
    productCoordinateString +=`        src="`;
    productCoordinateString +=item.resized_main_images[0].m;
    productCoordinateString +=`"`;
    productCoordinateString +=`        alt=""`;
    productCoordinateString +=`       >`;
    const acceptAt = new Date(item.accept_at);
    //公開日が1週間以内
    if (today < acceptAt) {
        productCoordinateString += `
              <div class="coordinate-card__tag__container">
                <p class="coordinate-card__tag">NEW</p>
              </div>`;
    }
    productCoordinateString +=`</div>`;
    productCoordinateString +=`     <div class="coordinate-card__link coordinate-card__height">`;
    productCoordinateString +=item.user_height;//165
    productCoordinateString +=`cm</div>`;
    productCoordinateString +=`    </a>`;
    productCoordinateString +=`    <a href="/pages/staff-detail-coordinate-${currentBrand}?user_id=${item.user_id}" class="coordinate-card__link coordinate-card__staff">`;
    productCoordinateString +=`      <img`;
    productCoordinateString +=`        class="coordinate-card__staff__image"`;
    productCoordinateString +=`        src="`;
    //スタッフ画像対応
    if(item.user_resized_images.length !== 0){
      let b = '';
      for(const a of item.user_resized_images){
          if(a.size === 'm'){
              b = a.url;
          }
      }
      if(b !== ''){
        productCoordinateString += b;
      } else {
        productCoordinateString += `${document.getElementById('ss-no-image').value}`;
      }
  } else {
    productCoordinateString += `${document.getElementById('ss-no-image').value}`;
  }
    //productCoordinateString +=item.user_image_url;//https://static.staff-start.com/img/staff/icon/42/f7baa5d5ed7d88c6b4a99873955915a0-46971/d16cc3c5367b911bae2681cd121ad6fe.jpg"`;
    productCoordinateString +=`"          alt=""`;
    productCoordinateString +=`        >`;
    productCoordinateString +=`      <div class="coordinate-card__staff__desc">`;
    productCoordinateString +=`        <div class="coordinate-card__link coordinate-card__staff-name">`;
    productCoordinateString +=item.user_name;//ダミースタッフ名ダミースタッフ名ダミースタッフ名
    productCoordinateString +=`</div>`;
    productCoordinateString +=`        <div class="coordinate-card__link coordinate-card__shop-name">`;
    productCoordinateString +=item.shop_name;//ダミー店舗名ダミー店舗名ダミー店舗名
    productCoordinateString +=`</div>`;
    productCoordinateString +=`      </div>`;
    productCoordinateString +=`    </a>`;
    productCoordinateString +=`  </div>`;
    productCoordinateString +=`</div>`;
    coordinatePcList.innerHTML +=productCoordinateString;
    coordinateSpList.innerHTML +=productCoordinateString;
    //spCoordinateElement.innerHTML +=productCoordinateString;
  }


  //もっと見るボタン
  var baseProductCode =location.pathname.replace(/\/+$/, "").split('/').pop().toUpperCase();
  var strhref="";
  const paramBaseProductList = baseProductCodeList.join();
  const coordinatePcShowMore = document.querySelector('.product-staff-start__product-coordinate-pc div');
  const coordinateSpShowMore = document.querySelector('.product-staff-start__product-coordinate-sp div');

  if (parseInt(productCoodinateResponse.total) > 8) {
    let showMoreButton = document.createElement('a');
    showMoreButton.classList.add('product-staff-start__show-more');
    strhref = `/pages/coordinate-${currentBrand}`;
    if(!!baseProductCode){
      strhref += "?base_product_code=";
      strhref += paramBaseProductList;
    }
    showMoreButton.href = strhref;
    showMoreButton.innerHTML ="もっと見る";
    coordinatePcShowMore.appendChild(showMoreButton);
  }

  if (parseInt(productCoodinateResponse.total) > 3) {
    let showMoreButton = document.createElement('a');
    showMoreButton.classList.add('product-staff-start__show-more');
    strhref =`/pages/coordinate-${currentBrand}`;
    if(!!baseProductCode){
      strhref += "?base_product_code=";
      strhref += paramBaseProductList;
    }
    showMoreButton.innerHTML ="もっと見る";
    showMoreButton.href = strhref;
    coordinateSpShowMore.appendChild(showMoreButton);
  }

}

/**
 *  コーディネート取得API実行
 * @returns
 */
function executionCoordinateApi(productCoordinateSearchParams){

  var staffStartProductCoordinateApiUrl =`https://${STAFFSTARTAPI_DOMAIN}/v1/coordinate/?merchant_id=${MERCHANT_ID}`;
  var paramBaseProductCode = location.pathname.replace(/\/+$/, "").split('/').pop().toUpperCase();
  const paramBaseProductList = baseProductCodeList.join();
  if(!!paramBaseProductCode){
    staffStartProductCoordinateApiUrl += "&base_product_code=";
    staffStartProductCoordinateApiUrl += paramBaseProductList;
  }
  staffStartProductCoordinateApiUrl += "&coordinate_genre=1,2";
  return fetch(staffStartProductCoordinateApiUrl)
      .then(productCoodinateResponse => productCoodinateResponse.json())
      .catch(error => {
          console.error(error);
      });
}

/**
 * ボイス一覧検索
 */
 async function getProdctVoice(){
  var productVoiceSearchParams = new URLSearchParams(window.location.search);
  const productVoiceResponse = await executionVoiceApi(productVoiceSearchParams);
  if(productVoiceResponse.total == 0) {
    document.querySelector('.product-staff-start__product-voice-pc').style.display = 'none';
    document.querySelector('.product-staff-start__product-voice-sp').style.display = 'none';
  } else {
    const stylingTab = document.querySelectorAll('.productDetail__info__tab__tablinks__styling')[1];
    stylingTab.style.display = 'block';
  }
  productStatusCheck(productVoiceResponse);

  //PC,SP用の要素を取得
  const paramBaseProductList = baseProductCodeList.join();
  const voicePcList = document.getElementById("product-voice-pc");
  const voiceSpList = document.getElementById("product-voice-sp");

  let currentBrand = document.querySelector('.productDetail__info__brand__name').innerHTML.trim();

  const siteBrands = window.siteBrandData;
  const matchedBrand = siteBrands.find(brand => brand.label == currentBrand);
  currentBrand = matchedBrand.mainCode;

  //もっと見るボタン  
  const voicePcShowMore = document.querySelector('.product-staff-start__product-voice-pc div');
  const voiceSpShowMore = document.querySelector('.product-staff-start__product-voice-sp div');
  var baseProductCode =location.pathname.replace(/\/+$/, "").split('/').pop();
  var strhref="";

  if (parseInt(productVoiceResponse.total) > 8) {
    let showMoreButton = document.createElement('a');
    showMoreButton.classList.add('product-staff-start__show-more');
    strhref = `/pages/voice-${currentBrand}`;
    if(!!baseProductCode){
      strhref += "?base_product_code=";
      strhref += paramBaseProductList;
    }
    showMoreButton.href = strhref;
    showMoreButton.innerHTML ="もっと見る";
    voicePcShowMore.appendChild(showMoreButton);
  }

  if (parseInt(productVoiceResponse.total) > 3) {
    let showMoreButton = document.createElement('a');
    showMoreButton.classList.add('product-staff-start__show-more');
    strhref = `/pages/voice-${currentBrand}`;
    if(!!baseProductCode){
      strhref += "?base_product_code=";
      strhref += paramBaseProductList;
    }
    showMoreButton.href = strhref;
    showMoreButton.innerHTML ="もっと見る";
    voiceSpShowMore.appendChild(showMoreButton);
  }

  var today = new Date(Date.now());
  today.setDate(today.getDate() -7);
  for (const item of productVoiceResponse.item) {
    const fromHeight = parseInt(item.user_height) <= 149 ? '0' : parseInt(item.user_height) >= 190 ? '190' : item.user_height;
    const toHeight = parseInt(item.user_height) <= 149 ? '149' : `${(parseInt(item.user_height) + 4)}`;
    var productCoordinateString = "";
    productCoordinateString +=`<div class="coordinate-card__container">`;
    productCoordinateString +=`  <div class="coordinate-card__content">`;
    productCoordinateString +=`    <a href="/pages/voice-detail-${currentBrand}?cid=`;
    productCoordinateString +=item.cid;
    productCoordinateString +=`" class="coordinate-card__image__link">`;
    productCoordinateString +=`      <div class="coordinate-card__image-container">`;
    productCoordinateString +=`       <img`;
    productCoordinateString +=`        class="coordinate-card__image"`;
    productCoordinateString +=`        src="`;
    productCoordinateString +=item.resized_main_images[0].m;
    productCoordinateString +=`"`;
    productCoordinateString +=`        alt=""`;
    productCoordinateString +=`       >`;
    const acceptAt = new Date(item.accept_at);
    //公開日が1週間以内
    if (today < acceptAt) {
        productCoordinateString += `
              <div class="coordinate-card__tag__container">
                <p class="coordinate-card__tag">NEW</p>
              </div>`;
    }
    productCoordinateString +=`</div>`;
    productCoordinateString +=`    </a>`;
    productCoordinateString +=`      <a href="/pages/staff-detail-voice-${currentBrand}?user_id=${item.user_id}" class="coordinate-card__link coordinate-card__staff">`;
    productCoordinateString +=`        <img`;
    productCoordinateString +=`          class="coordinate-card__staff__image"`;
    productCoordinateString +=`          src="`;
    if(item.user_resized_images.length !== 0){
      let b = '';
      for(const a of item.user_resized_images){
          if(a.size === 'm'){
              b = a.url;
          }
      }
      if(b !== ''){
        productCoordinateString += b;
      } else {
        productCoordinateString += `${document.getElementById('ss-no-image').value}`;
      }
  } else {
    productCoordinateString += `${document.getElementById('ss-no-image').value}`;
  }
    //productCoordinateString +=item.user_image_url;//https://static.staff-start.com/img/staff/icon/42/f7baa5d5ed7d88c6b4a99873955915a0-46971/d16cc3c5367b911bae2681cd121ad6fe.jpg"`;
    productCoordinateString +=`"          alt=""`;
    productCoordinateString +=`        >`;
    productCoordinateString +=`          <div class="coordinate-card__staff__desc">`;
    productCoordinateString +=`            <div class="coordinate-card__link coordinate-card__staff-name">`;
    productCoordinateString +=item.user_name;//ダミースタッフ名ダミースタッフ名ダミースタッフ名
    productCoordinateString +=`</div>`;
    productCoordinateString +=`            <div class="coordinate-card__link coordinate-card__shop-name">`;
    productCoordinateString +=item.shop_name;//ダミー店舗名ダミー店舗名ダミー店舗名
    productCoordinateString +=`</div>`;
    productCoordinateString +=`     </div>`;
    productCoordinateString +=`    </a>`;
    productCoordinateString +=`  </div>`;
    productCoordinateString +=`</div>`;
    voicePcList.innerHTML +=productCoordinateString;
    voiceSpList.innerHTML +=productCoordinateString;
    //spCoordinateElement.innerHTML +=productCoordinateString;
  }

}


/**
 *  ボイス取得API実行
 * @returns
 */
 function executionVoiceApi(productVoiceSearchParams){

  var staffStartProductVoiceApiUrl =`https://${STAFFSTARTAPI_DOMAIN}/v1/coordinate/?merchant_id=${MERCHANT_ID}`;
  var paramBaseProductCode = location.pathname.replace(/\/+$/, "").split('/').pop().toUpperCase();
  const paramBaseProductList = baseProductCodeList.join();
  if(!!paramBaseProductCode){
    staffStartProductVoiceApiUrl += "&base_product_code=";
    staffStartProductVoiceApiUrl += paramBaseProductList;
  }
  staffStartProductVoiceApiUrl +="&coordinate_genre=4";
  return fetch(staffStartProductVoiceApiUrl)
      .then(productVoiceResponse => productVoiceResponse.json())
      .catch(error => {
          console.error(error);
      });
}



/****************************************************
 * ステータスチェック
 ****************************************************/
  function productStatusCheck(productCoodinateResponse){
  //ステータス判定
  if (typeof productCoodinateResponse.code === 'undefined' || productCoodinateResponse.code === null || productCoodinateResponse.code === '-1' ) {
  //要素の判定例2
  let errorMessage = '';
  if (typeof productCoodinateResponse.code === 'undefined' || productCoodinateResponse.code === null) {
      errorMessage = 'レスポンスJSONが不正';
  } else {
      errorMessage = 'レスポンスエラー(code : -1)';
  }
  //判定例2の圧縮記述方法
  const errorMessage2 = productCoodinateResponse.code === undefined || productCoodinateResponse.code === null ? 'レスポンスJSONが不正' : 'レスポンスエラー';
  }
}

/**
 * 不要な子要素の削除
 * @param {削除対象} removeTarget
 */
function removeChild(removeTarget){
  if(!!removeTarget){
      while(removeTarget.lastChild){
          removeTarget.removeChild(removeTarget.lastChild);
      }
  }
}
